import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
// import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Users from './components/Users';
//import Groups from './components/Groups';
import Groups from './components/admin/Groups';
// import Forms from './components/Forms';
import FormsWithCategories from './components/FormsWithCategories';
import FormsSelection from './components/FormsSelection';
import FormFilling from './components/FormFilling';
import PublicForm from './components/PublicForm';
import PublicFormAuth from './components/PublicFormAuth';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Register from './components/Register';
import AdminSettings from './components/admin/AdminSettings';
import ClientTypes from './components/admin/ClientTypes';
import FormCategories from './components/admin/FormCategories';
import Blocks from './components/admin/Blocks';
import MasterDataList from './components/MasterData/MasterDataList';
import MasterDataDetail from './components/MasterData/MasterDataDetail';
import CreateMasterData from './components/CreateMasterData';
import TaskList from './components/Tasks/TaskList';
import TaskDetails from './components/Tasks/TaskDetails';
import TaskDetail from './components/Tasks/TaskDetail';
import CreateTask from './components/CreateTask';
import UploadFields from './components/admin/UploadFields';
import VerificationTypes from './components/admin/VerificationTypes';
import TaskTemplates from './components/admin/TaskTemplates';
import ProductManagement from './components/admin/ProductManagement';
import ProductForm from './components/admin/ProductForm';
import ProductDetail from './components/admin/ProductDetail';
// import VerificationPage from './components/DocumentVerification/VerificationPage';
import EmailGateways from './components/admin/EmailGateways';
import FormSubmissions from './components/FormSubmissions/FormSubmissions';
import InvoiceList from './components/Invoices/InvoiceList';
import InvoiceForm from './components/Invoices/InvoiceForm';
import InvoiceDetails from './components/Invoices/InvoiceDetails';
import InvoiceSettings from './components/admin/InvoiceSettings';
import DocumentVerificationSettings from './components/admin/DocumentVerificationSettings';
import DocumentVerificationList from './components/DocumentVerificationList';
// import { navigation } from './config/navigation';
import Admin from './components/Admin';
import EmailTemplates from './components/admin/EmailTemplates';
import FormsAndTasks from './components/FormsAndTasks';
import FormSubmissionDetails from './components/FormSubmissions/FormSubmissionDetails';
import './App.css';
import './styles/pasteUpload.css';
import CustomPages from './components/admin/CustomPages';
import CustomPageRenderer from './components/CustomPageRenderer';
import CustomPageSubmissions from './components/CustomPageSubmissions';
import CustomMenuSubmissions from './components/CustomMenuSubmissions';
import CustomPageSubmissionsTable from './components/CustomPageSubmissionsTable';
import CustomPageSubmissionDetail from './components/CustomPageSubmissionDetail';
import CustomPageSubmissionEdit from './components/CustomPageSubmissionEdit';
import CustomDocuments from './components/admin/CustomDocuments';
import PublicFormPage from './components/PublicFormPage';
import DocxEditor from './components/DocxEditor/DocxEditor';
import DocxEditorList from './components/DocxEditor/DocxEditorList';
import ClientDetails from './components/ClientDetails';
import TrademarkApplication from './components/TrademarkApplication';
import TrademarkApplicationsList from './components/TrademarkApplicationsList';
import FilingQueue from './components/FilingQueue';
import TrademarkSettings from './components/admin/TrademarkSettings';
import ClassAutocompleteTest from './components/ClassAutocompleteTest';
import PaymentSettings from './components/admin/PaymentSettings';
import AdminDocumentGeneration from './components/admin/DocumentGeneration';
import TemplateUpload from './components/admin/TemplateUpload';
import FieldMapping from './components/admin/FieldMapping';
import GenerateDocuments from './components/admin/GenerateDocuments';
import CustomIdSettings from './components/admin/CustomIdSettings';
import ApiIntegrationSettings from './components/admin/ApiIntegrationSettings';
import PrefillingSettings from './pages/admin/PrefillingSettings';
import PoaDocumentGenerator from './components/admin/PoaDocumentGenerator';
import TrademarkPortfolio from './components/TrademarkPortfolio';
import TrademarkPortfolioDetail from './components/TrademarkPortfolioDetail';
import TrademarkChangesList from './components/TrademarkChangesList';
import CitedMarks from './components/CitedMarks';
import OppositionChanges from './components/OppositionChanges';
import Hearings from './components/Hearings';
import Compliances from './components/Compliances';
import Oppositions from './components/Oppositions';
import TrademarkImport from './components/TrademarkImport';
import NameCheck from './components/NameCheck';
import NewCourtCases from './components/NewCourtCases';
import DocumentGeneration from './components/DocumentGeneration';
import IndiaPost from './components/IndiaPost';
import TimeLogForm from './components/TimeLogForm';
import Profile from './components/Profile';

// Map component names to actual components
// eslint-disable-next-line no-unused-vars
const componentMap = {
  Dashboard,
  Users,
  Groups,
  // Forms,
  FormsWithCategories,
  FormsSelection,
  FormFilling,
  MasterDataList,
  CreateMasterData,
  TaskList,
  CreateTask,
  AdminSettings,
  ClientTypes,
  FormCategories,
  ProductManagement,
  ProductForm,
  UploadFields,
  VerificationTypes,
  EmailGateways,
  FormSubmissions,
  InvoiceList,
  InvoiceForm,
  InvoiceDetails,
  InvoiceSettings,
  FormsAndTasks,
  DocumentVerificationSettings,
  DocumentVerificationList,
  CustomPages,
  CustomPageSubmissionsTable,
  TrademarkSettings,
  ClassAutocompleteTest,
  Compliances,
  Oppositions,
  NewCourtCases,
  DocumentGeneration,
  AdminDocumentGeneration,
  IndiaPost,
  TimeLogForm
};

function App() {
  console.log('App component rendered');

  return (
    <>

      <ThemeProvider>

        <AuthProvider>
          <div className="App">
            <Router>
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/public-form/:slug" element={<PublicForm />} />
                <Route path="/public-form/:slug/auth" element={<PublicFormAuth />} />
                {/* Custom Page Public Form Route */}
                <Route path="/public-form-custom/:token" element={<PublicFormPage />} />
                

                {/* DOCX Editor Routes */}
                <Route path="/docx-editor" element={<DocxEditor />} />
                <Route path="/docx-editor/list" element={<DocxEditorList />} />

                {/* Protected routes */}
                <Route path="/" element={<Layout />}>
                  {/* Dashboard */}
                  <Route
                    index
                    element={
                      <PrivateRoute requiredPermission="View Dashboard">
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="dashboard"
                    element={
                      <PrivateRoute requiredPermission="View Dashboard">
                        <Dashboard />
                      </PrivateRoute>
                    }
                  />

                  {/* Profile - no permission required */}
                  <Route
                    path="profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  />

                  {/* New Menu Routes */}
                  <Route
                    path="new/master-data"
                    element={
                      <PrivateRoute requiredPermission="View Master Data">
                        <CreateMasterData />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/task"
                    element={
                      <PrivateRoute requiredPermission="View Tasks">
                        <CreateTask />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/invoice"
                    element={
                      <PrivateRoute requiredPermission="View Invoices">
                        <InvoiceForm />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/forms"
                    element={
                      <PrivateRoute requiredPermission="View Forms">
                        <FormsSelection />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/trademark-application"
                    element={
                      <PrivateRoute requiredPermission="Create Trademark Applications">
                        <TrademarkApplication />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/court-cases"
                    element={
                      <PrivateRoute requiredPermission="Create Court Cases">
                        <NewCourtCases />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="new/india-post"
                    element={
                      <PrivateRoute requiredPermission="Create India Post">
                        <IndiaPost />
                      </PrivateRoute>
                    }
                  />
            <Route
              path="new/time-log"
              element={
                <PrivateRoute requiredPermission="Create Time Logs">
                  <TimeLogForm />
                </PrivateRoute>
              }
            />
                  <Route
                    path="new/form/:slug"
                    element={
                      <PrivateRoute requiredPermission="View Forms">
                        <FormFilling />
                      </PrivateRoute>
                    }
                  />

                  {/* Master Data */}
                  <Route
                    path="master-data"
                    element={
                      <PrivateRoute requiredPermission="View Master Data">
                        <MasterDataList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="master-data/:id"
                    element={
                      <PrivateRoute requiredPermission="View Master Data">
                        <MasterDataDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="client/:clientId"
                    element={
                      <PrivateRoute requiredPermission="View Master Data">
                        <ClientDetails />
                      </PrivateRoute>
                    }
                  />

                  {/* Forms & Tasks */}
                  <Route
                    path="forms-and-tasks"
                    element={<FormsAndTasks />}
                  />

                  {/* Form Submissions */}
                  <Route
                    path="form-submissions"
                    element={
                      <PrivateRoute requiredPermission="View Form Submissions">
                        <FormSubmissions />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="form-submissions/:id"
                    element={
                      <PrivateRoute requiredPermission="View Form Submissions">
                        <FormSubmissionDetails />
                      </PrivateRoute>
                    }
                  />

                  {/* Custom Page Submission Detail */}
                  <Route
                    path="custom-page-submissions/:submissionId"
                    element={
                      <PrivateRoute requiredPermission="View Custom Page Submissions">
                        <CustomPageSubmissionDetail />
                      </PrivateRoute>
                    }
                  />

                  {/* Tasks */}
                  <Route
                    path="tasks"
                    element={
                      <PrivateRoute requiredPermission="View Tasks">
                        <TaskList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="tasks/:taskId"
                    element={
                      <PrivateRoute requiredPermission="View Tasks">
                        <TaskDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="tasks/:id"
                    element={
                      <PrivateRoute requiredPermission="View Tasks">
                        <TaskDetail />
                      </PrivateRoute>
                    }
                  />

                  {/* Invoices */}
                  <Route
                    path="invoices"
                    element={
                      <PrivateRoute requiredPermission="View Invoices">
                        <InvoiceList />
                      </PrivateRoute>
                    }
                  />

                  {/* API Data */}
                  <Route
                    path="api-data/trademark-portfolio"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <TrademarkPortfolio />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="api-data/compliances"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <Compliances />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="api-data/oppositions"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <Oppositions />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="name-check"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <NameCheck />
                      </PrivateRoute>
                    }
                  />  
                  <Route
                    path="api-data/trademark-portfolio/:appno"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <TrademarkPortfolioDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="api-data/trademark-changes/:appno"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <TrademarkPortfolioDetail />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/api-data/trademark-changes-list"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <TrademarkChangesList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/api-data/cited-marks"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <CitedMarks />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/api-data/opposition-changes"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <OppositionChanges />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/api-data/hearings"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <Hearings />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="/api-data/trademark-import"
                    element={
                      <PrivateRoute requiredPermission="View Admin Settings">
                        <TrademarkImport />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="invoices/new"
                    element={
                      <PrivateRoute requiredPermission="Create Invoice">
                        <InvoiceForm />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="invoices/:id"
                    element={
                      <PrivateRoute requiredPermission="View Invoice">
                        <InvoiceDetails />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="invoices/:id/edit"
                    element={
                      <PrivateRoute requiredPermission="Update Invoice">
                        <InvoiceForm />
                      </PrivateRoute>
                    }
                  />

                  {/* Trademark Applications */}
                  <Route
                    path="trademark-applications"
                    element={
                      <PrivateRoute requiredPermission="View Trademark Applications">
                        <TrademarkApplicationsList />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="trademark-applications/new"
                    element={
                      <PrivateRoute requiredPermission="Create Trademark Applications">
                        <TrademarkApplication />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="trademark-applications/:id"
                    element={
                      <PrivateRoute requiredPermission="View Trademark Applications">
                        <TrademarkApplication />
                      </PrivateRoute>
                    }
                  />
                  <Route
                    path="trademark-filing-queue"
                    element={
                      <PrivateRoute>
                        <FilingQueue />
                      </PrivateRoute>
                    }
                  />



                  {/* Admin Routes */}
                  <Route
                    path="admin"
                    element={
                      <PrivateRoute requiredPermissions={[
                        'View Users',
                        'View Groups',
                        'View Forms',
                        'View Client Types',
                        'View Products',
                        'View Upload Fields',
                        'View Verification Types',
                        'View Email Gateways',
                        'View Email Templates',
                        'View Invoice Settings',
                        'View Admin Settings',
                        'View Custom Pages',
                        'View Trademark Settings',
                        'View Custom Page Submissions',
                        'View Document Templates',
                        'Generate Documents'
                      ]}>
                        <Admin />
                      </PrivateRoute>
                    }
                  >

                    {/* Checklist */}
                    <Route
                      path="checklist"
                      element={
                        <PrivateRoute requiredPermission="View Admin Settings">
                          <DocumentVerificationList />
                        </PrivateRoute>
                      }
                    />
                    {/* Users */}
                    <Route
                      path="users"
                      element={
                        <PrivateRoute requiredPermission="View Users">
                          <Users />
                        </PrivateRoute>
                      }
                    />

                    {/* Groups */}
                    <Route
                      path="groups"
                      element={
                        <PrivateRoute requiredPermission="View Groups">
                          <Groups />
                        </PrivateRoute>
                      }
                    />

                    {/* Trademark Settings */}
                    <Route
                      path="trademark-settings"
                      element={
                        <PrivateRoute requiredPermission="View Trademark Settings">
                          <TrademarkSettings />
                        </PrivateRoute>
                      }
                    />

                    {/* Forms Management */}
                    <Route
                      path="forms"
                      element={
                        <PrivateRoute requiredPermission="View Forms">
                          <FormsWithCategories />
                        </PrivateRoute>
                      }
                    />

                    {/* Custom Page Submissions Table */}
                    <Route
                      path="custom-page-submissions/:pageId"
                      element={
                        <PrivateRoute requiredPermission="View Custom Page Submissions">
                          <CustomPageSubmissionsTable />
                        </PrivateRoute>
                      }
                    />

                    {/* Custom Page Submission Edit */}
                    <Route
                      path="custom-page-submissions/:pageId/edit/:submissionId"
                      element={
                        <PrivateRoute requiredPermission="Update Custom Page Submission">
                          <CustomPageSubmissionEdit />
                        </PrivateRoute>
                      }
                    />

                    {/* Admin Settings */}
                    <Route
                      path="settings"
                      element={
                        <PrivateRoute requiredPermissions={[
                          'View Admin Settings',
                          'View Custom Pages',
                          'View Payment Settings',
                          'View Client Types',
                          'View Form Categories',
                          'View Custom Page Submissions',
                          'View Products',
                          'View Upload Fields',
                          'View Verification Types',
                          'View Email Gateways',
                          'View Email Templates',
                          'View Invoice Settings',
                          'View Blocks',
                          'View Custom Page Documents',
                          'View Document Templates'
                        ]}>
                          <AdminSettings />
                        </PrivateRoute>
                      }
                    >
                      {/* Payment Settings */}
                      <Route
                        path="payment-settings"
                        element={
                          <PrivateRoute requiredPermission="View Payment Settings">
                            <PaymentSettings />
                          </PrivateRoute>
                        }
                      />
                      {/* Client Types */}
                      <Route
                        path="client-types"
                        element={
                          <PrivateRoute requiredPermission="View Client Types">
                            <ClientTypes />
                          </PrivateRoute>
                        }
                      />

                      {/* Form Categories */}
                      <Route
                        path="form-categories"
                        element={
                          <PrivateRoute requiredPermission="View Form Categories">
                            <FormCategories />
                          </PrivateRoute>
                        }
                      />

                      {/* Custom Pages */}
                      <Route
                        path="custom-pages"
                        element={
                          <PrivateRoute requiredPermission="View Custom Pages">
                            <CustomPages />
                          </PrivateRoute>
                        }
                      />

                      {/* Custom Page Renderer */}
                      <Route
                        path="custom-page/:pageId"
                        element={
                          <PrivateRoute requiredPermission="View Custom Pages">
                            <CustomPageRenderer />
                          </PrivateRoute>
                        }
                      />

                      {/* Custom Menu Submissions */}
                      <Route
                        path="custom-menu-submissions"
                        element={
                          <PrivateRoute requiredPermission="View Custom Page Submissions">
                            <CustomMenuSubmissions />
                          </PrivateRoute>
                        }
                      />

                      {/* Products */}
                      <Route
                        path="products"
                        element={
                          <PrivateRoute requiredPermission="View Products">
                            <ProductManagement />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="products/new"
                        element={
                          <PrivateRoute requiredPermission="Create Product">
                            <ProductForm />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="products/:id"
                        element={
                          <PrivateRoute requiredPermission="View Products">
                            <ProductDetail />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="products/:id/edit"
                        element={
                          <PrivateRoute requiredPermission="Update Product">
                            <ProductForm />
                          </PrivateRoute>
                        }
                      />

                      {/* Upload Fields */}
                      <Route
                        path="upload-fields"
                        element={
                          <PrivateRoute requiredPermission="View Upload Fields">
                            <UploadFields />
                          </PrivateRoute>
                        }
                      />

                      {/* Verification Types */}
                      <Route
                        path="verification-types"
                        element={
                          <PrivateRoute requiredPermission="View Verification Types">
                            <VerificationTypes />
                          </PrivateRoute>
                        }
                      />

                      {/* Task Templates */}
                      <Route
                        path="task-templates"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <TaskTemplates />
                          </PrivateRoute>
                        }
                      />

                      {/* Email Gateways */}
                      <Route
                        path="email-gateways"
                        element={
                          <PrivateRoute requiredPermission="View Email Gateways">
                            <EmailGateways />
                          </PrivateRoute>
                        }
                      />

                      {/* Email Templates */}
                      <Route
                        path="email-templates"
                        element={
                          <PrivateRoute requiredPermission="View Email Templates">
                            <EmailTemplates />
                          </PrivateRoute>
                        }
                      />

                      {/* Invoice Settings */}
                      <Route
                        path="invoice-settings"
                        element={
                          <PrivateRoute requiredPermission="View Invoice Settings">
                            <InvoiceSettings />
                          </PrivateRoute>
                        }
                      />

                      {/* Custom ID Settings */}
                      <Route
                        path="custom-id-settings"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <CustomIdSettings />
                          </PrivateRoute>
                        }
                      />

                      {/* API Integration Settings */}
                      <Route
                        path="api-integration-settings"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <ApiIntegrationSettings />
                          </PrivateRoute>
                        }
                      />

                      {/* Blocks */}
                      <Route
                        path="blocks"
                        element={
                          <PrivateRoute requiredPermission="View Blocks">
                            <Blocks />
                          </PrivateRoute>
                        }
                      />

                      {/* Prefilling Settings */}
                      <Route
                        path="prefilling-settings"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <PrefillingSettings />
                          </PrivateRoute>
                        }
                      />

                      {/* Generate POA Document */}
                      <Route
                        path="poa-document-generator"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <PoaDocumentGenerator />
                          </PrivateRoute>
                        }
                      />

                      {/* Checklist */}
                      <Route
                        path="checklist-settings"
                        element={
                          <PrivateRoute requiredPermission="View Admin Settings">
                            <DocumentVerificationSettings />
                          </PrivateRoute>
                        }
                      />

                      {/* Custom Documents */}
                      <Route
                        path="custom-documents"
                        element={
                          <PrivateRoute requiredPermission="View Custom Page Documents">
                            <CustomDocuments />
                          </PrivateRoute>
                        }
                      />




                    </Route>
                    {/* Admin Document Generation */}
                    <Route
                      path="admin-document-generation"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <AdminDocumentGeneration />
                        </PrivateRoute>
                      }
                    />

                    {/* Admin Document Generation - Settings nested */}
                    <Route
                      path="settings/admin-document-generation"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <AdminDocumentGeneration />
                        </PrivateRoute>
                      }
                    />

                    {/* Document Generation Templates */}
                    <Route
                      path="admin-document-generation/templates"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <AdminDocumentGeneration />
                        </PrivateRoute>
                      }
                    />

                    {/* Settings - Document Generation Templates */}
                    <Route
                      path="settings/admin-document-generation/templates"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <AdminDocumentGeneration />
                        </PrivateRoute>
                      }
                    />

                    {/* Document Generation Template Upload */}
                    <Route
                      path="admin-document-generation/templates/new"
                      element={
                        <PrivateRoute requiredPermission="Create Document Templates">
                          <TemplateUpload />
                        </PrivateRoute>
                      }
                    />

                    {/* Settings - Document Generation Template Upload */}
                    <Route
                      path="settings/admin-document-generation/templates/new"
                      element={
                        <PrivateRoute requiredPermission="Create Document Templates">
                          <TemplateUpload />
                        </PrivateRoute>
                      }
                    />

                    {/* Document Generation Template View */}
                    <Route
                      path="admin-document-generation/templates/:id"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <FieldMapping />
                        </PrivateRoute>
                      }
                    />

                    {/* Settings - Document Generation Template View */}
                    <Route
                      path="settings/admin-document-generation/templates/:id"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <FieldMapping />
                        </PrivateRoute>
                      }
                    />

                    {/* Document Generation Template Edit */}
                    <Route
                      path="admin-document-generation/templates/:id/edit"
                      element={
                        <PrivateRoute requiredPermission="Update Document Templates">
                          <FieldMapping />
                        </PrivateRoute>
                      }
                    />

                    {/* Settings - Document Generation Template Edit */}
                    <Route
                      path="settings/admin-document-generation/templates/:id/edit"
                      element={
                        <PrivateRoute requiredPermission="Update Document Templates">
                          <FieldMapping />
                        </PrivateRoute>
                      }
                    />

                    {/* Document Generation - Generate Documents */}
                    <Route
                      path="admin-document-generation/generate"
                      element={
                        <PrivateRoute requiredPermission="Generate Documents">
                          <GenerateDocuments />
                        </PrivateRoute>
                      }
                    />

                    {/* Settings - Document Generation - Generate Documents */}
                    <Route
                      path="settings/admin-document-generation/generate"
                      element={
                        <PrivateRoute requiredPermission="Generate Documents">
                          <GenerateDocuments />
                        </PrivateRoute>
                      }
                    />

                    {/* Legacy route for backward compatibility */}
                    <Route
                      path="document-templates"
                      element={
                        <PrivateRoute requiredPermission="View Document Templates">
                          <AdminDocumentGeneration />
                        </PrivateRoute>
                      }
                    />

                    {/* User Document Generation Route - in Admin */}
                    <Route
                      path="document-generation"
                      element={
                        <PrivateRoute requiredPermission="Generate Documents">
                          <DocumentGeneration />
                        </PrivateRoute>
                      }
                    />
                  </Route>

                </Route>

                {/* Custom Page Routes */}
                <Route
                  path="custom-page/:pageId"
                  element={
                    <PrivateRoute requiredPermissions={['View Custom Pages', 'Create Custom Page Submission']}>
                      <CustomPageRenderer />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="custom-page/:pageId/submissions"
                  element={
                    <PrivateRoute requiredPermission="View Custom Page Submissions">
                      <CustomPageSubmissions />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="custom-page/:pageId/submissions/table"
                  element={
                    <PrivateRoute requiredPermission="View Custom Page Submissions">
                      <CustomPageSubmissionsTable />
                    </PrivateRoute>
                  }
                />

                {/* Catch all route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Router>
          </div>
        </AuthProvider>
      </ThemeProvider>
    </>
  );
}

export default App; 
